import { getAppByVersion } from '@wix/ambassador-devcenter-apps-v1-app/http';
import type { GetAppResponse } from '@wix/ambassador-devcenter-apps-v1-app/types';
import type { HttpClient } from '@wix/http-client';

const fetchAppInfo = async (
  httpClient: HttpClient,
  appId: string,
  version: string = 'latest',
): Promise<GetAppResponse | undefined> => {
  const { data } = await httpClient.request(
    getAppByVersion({
      appId,
      version,
    }),
  );

  return data;
};

export { fetchAppInfo };
